'use client';
import { useEffect } from 'react';
import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import BookingSection from './components/BookingSection';
import BookingFormSection from './components/BookingFormSection';
import WhatsAppButton from '../homepage/components/WhatsAppButton';

export default function BookAppointmentPage() {
  useEffect(() => {
    const reveals = document.querySelectorAll('.reveal')
    if (!reveals?.length) return

    const observer = new IntersectionObserver(
      (entries) => entries.forEach(e => e.isIntersecting && e.target.classList.add('active')),
      { threshold: 0.1 }
    )
    reveals?.forEach(el => observer?.observe(el))

    return () => observer?.disconnect();
  }, [])

  return (
    <>
      <Header />
      <main className="pt-20">
        <div className="py-16 bg-background">
          <div className="max-w-7xl mx-auto px-6">
            <BookingFormSection />
          </div>
        </div>
        <BookingSection />
      </main>
      <Footer />
      <WhatsAppButton />
    </>
  )
}